export function getTenantPlusCookiesValue(): boolean {
  const cookieValue =
    typeof document === 'undefined'
      ? ''
      : (document.cookie?.match(/isTenantPlusSubscriber=(\w+)/i)?.[1].toLowerCase() ?? '');

  return cookieValue === 'true';
}
